import { useEffect } from 'react';
import { GlobalStatesV3 } from '../states/GlobalStatesV3';
import { V3Routes } from '../../mainv3/routes';

/**
 * ページへのアクセスを会員のみに制限する際に使うHooks
 * 権限のないユーザがアクセスした場合には、ログインページにリダイレクトされる
 */
export const restrictAccessForUser = () => {
  useEffect(() => {
    if (GlobalStatesV3.currentUser.isSignedIn()) {
      return;
    } else {
      GlobalStatesV3.routing.push(V3Routes.signIn(location.href));
    }
  });
};
